/**
 * @file index.tsx
 *
 * @fileoverview Populates script with provided content.
 *  Only the content admin sets this so we can trust that content is not harmful.
 */
import React from 'react';
import { useClientScriptInsert } from '~/jobiqo/hooks/useClientScriptInsert';
import { InsecureScriptParagraph } from '~/jobiqo/types/types';

interface InsecureScriptProps {
  /**
   * A unique row identifier for the row.
   */
  identifier: string;
  /**
   * The row element (from the backend landing page row).
   */
  row: InsecureScriptParagraph;
  /**
   * The size for the container.
   */
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}

const InsecureScript = ({ identifier, row }: InsecureScriptProps) => {
  const { strippedJsString } = useClientScriptInsert({
    content: row.scriptContent ?? '',
    id: identifier,
    identifier: 'landingpage',
  });

  return row.scriptContent ? (
    <div
      dangerouslySetInnerHTML={{
        __html: strippedJsString ?? '',
      }}
    />
  ) : null;
};

export default InsecureScript;
